import { Injectable } from '@angular/core';
import { AngularFirestore, AngularFirestoreDocument } from '@angular/fire/compat/firestore';
import { Project } from '../../models/project';
import firebase from 'firebase/compat/app';
@Injectable({
	providedIn: 'root'
})
export class DbService {

	firestore = this.ngFirestore.firestore;

	constructor(
		private ngFirestore: AngularFirestore
	) { }

	public getProyIdRef(projectId: string): firebase.firestore.DocumentReference {
		return this.firestore.collection(Project.PATH).doc(projectId);
	}

	getData(projectId: string, path: string) {
		return this.getProyIdRef(projectId).collection(path).get();
	}

	generateFirebaseUniqueId(): string {
		return this.firestore.collection('dummyCollection').doc().id;
	}

}
